export default "__VITE_ASSET__DGsAZMcu__"